import './tipsy.less';

import React from 'react';
import RcTooltip from 'rc-tooltip';
import classNames from 'classnames';
import 'rc-tooltip/assets/bootstrap.css';

const FauxTipsy = ({ content, mouseEnterDelay, className, mouseLeaveDelay = 0, ...props })=> (
  <RcTooltip 
    popupClassName={classNames('zf-tipsy', className)}
    overlay={content}
    mouseEnterDelay={mouseEnterDelay}
    mouseLeaveDelay={mouseLeaveDelay}
    {...props}
  />
);

FauxTipsy.defaultProps = {
  placement: 'bottom',
  mouseEnterDelay: 0.7
};


const SafeTipsy = ({ content, children, ...props })=> (
  content ?
    <FauxTipsy content={content} {...props}>
      {children}
    </FauxTipsy>
  :
    children
);


export {
  SafeTipsy
};

export default FauxTipsy;
